/* 
 * Service helps to know more about curreny logged user
 */

app.service("_$user",function($http){
   
    
    //check if we have this id in logged user
    this.checkId=function(id){
      
        return $http.get("/user/checkid/"+id).then(function(response){ return response.data.match });
    };
    
});


